import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Formik } from 'formik'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import withApiError, {
  ERROR_TYPE_CONTENTFUL,
  SHOW_CONTENT_ON_401,
} from 'layers/errorHandling/apiError'
import {
  actions as siteActions,
  operations as siteOperations,
  selectors as siteSelectors,
} from 'store/siteManager'
import AddUserPlanModal from './component'
import { ENTRY_ID, fieldNames, validationSchema } from './data'

export const AddUserPlanModalContainer = ({
  clearError,
  flowLabel,
  handleClose,
  hasApiError,
  modals,
  siteId,
  updateSitePreferences,
  userInvitationMethod,
}) => {
  if (!modals) return null

  const closeModal = () => {
    clearError('sitePreferences')
    handleClose()
  }

  const getInitialValues = () => {
    return {
      userInvitationMethod: userInvitationMethod || 'DuringKickoffMeeting',
    }
  }

  const handleSave = async values => {
    const newSitePreferences = {
      k5Digital: {
        userInvitationMethod: values.userInvitationMethod,
      },
      mspDigital: {
        userInvitationMethod: values.userInvitationMethod,
      },
    }

    await updateSitePreferences(siteId, newSitePreferences)
  }

  const modalContent = modals?.[0]

  return (
    <Formik
      enableReinitialize
      initialValues={getInitialValues()}
      validationSchema={validationSchema}
    >
      {({
        errors,
        isSubmitting,
        setFieldTouched,
        setFieldValue,
        setSubmitting,
        setTouched,
        touched,
        values,
      }) => (
        <AddUserPlanModal
          choiceContent={modalContent.choiceContent}
          errors={errors}
          flowLabel={flowLabel}
          handleChange={(name, value) => {
            setFieldTouched(name)
            setFieldValue(name, value)
          }}
          handleClose={closeModal}
          handleNextButtonClick={async () => {
            const isValidSync = validationSchema.isValidSync(values)
            if (!isValidSync) {
              const touchedFields = fieldNames.reduce((acc, name) => {
                acc[name] = true
                return acc
              }, {})
              await setTouched(touchedFields)
              return
            }
            setSubmitting(true)
            await handleSave(values)
            setSubmitting(false)
            closeModal()
          }}
          hasApiError={hasApiError}
          header={modalContent.header}
          helpCopy={modalContent.helpCopy}
          isSubmitting={isSubmitting}
          modals={modals}
          nextLabel={modalContent.nextLabel}
          touched={touched}
          values={values}
        />
      )}
    </Formik>
  )
}

AddUserPlanModalContainer.propTypes = {
  clearError: PropTypes.func.isRequired,
  flowLabel: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  hasApiError: PropTypes.bool.isRequired,
  modals: PropTypes.array,
  siteId: PropTypes.number.isRequired,
  updateSitePreferences: PropTypes.func.isRequired,
  userInvitationMethod: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => {
  const site = siteSelectors.selectSiteById(state, ownProps.siteId)
  const { sitePreferences = {} } = site || {}
  const { sitePreferences: sitePreferencesAPIResults } = state.siteManager
  const { error } = sitePreferencesAPIResults
  const userInvitationMethod = sitePreferences?.k5Digital?.userInvitationMethod

  return {
    userInvitationMethod,
    hasApiError: !!error,
    site,
  }
}

const mapDispatchToProps = {
  clearError: siteActions.clearError,
  updateSitePreferences: siteOperations.updateSitePreferences,
}

const mapper = entry => {
  const { flowLabel, modals } = entry || {}
  return {
    flowLabel,
    modals,
  }
}

const options = {
  entryId: ENTRY_ID,
  include: 3,
  mapper,
  spread: true,
}

export default ContentEntryDataGetter(
  withApiError(
    AddUserPlanModalContainer,
    [ERROR_TYPE_CONTENTFUL],
    [SHOW_CONTENT_ON_401],
  ),
  options,
  connect(mapStateToProps, mapDispatchToProps),
)
